import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MbscSelectOptions } from '@mobiscroll/angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { DefaultVendorInformation } from '../models/default-vendor-information.model';

@Component({
  selector: 'app-vendor-defaults',
  templateUrl: './vendor-defaults.component.html',
  styles: [
  ]
})
export class VendorDefaultsComponent implements OnInit {
  @ViewChild(NgForm) defaultForm!: NgForm;

  @Input() vendorId: string;

  vendorInfo: DefaultVendorInformation;
  submitAttempt: boolean = false;
  masterFileOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
  };

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.ajax.MakeCall<DefaultVendorInformation>('/Vendor/GetDefaults', { vendorId: this.vendorId }).then((data) => {
      this.vendorInfo = data;
    }, () => { });
  }

  save(): void {
    this.submitAttempt = true;
    if (this.defaultForm.invalid) {
      return;
    }
    this.ajax.MakeCall('/Vendor/SaveDefaults', this.vendorInfo).then(() => {
      this.modal.close();
    }, () => { });
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  markDirty(): void {
    this.defaultForm.form.markAsDirty();
  }
}
